import React, {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import cookie from 'js-cookie'
import { logOut } from '../../store/features/OTPSlice'
import { getDetail } from '../../store/features/SPAJSlice'
import { Row, Col } from 'react-bootstrap';
import styles from './RevisiDataPage.module.css'


export default function LandingPage() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { SPAJDetail } = useSelector((state)=> state.SPAJsDetail)
  const userAgent = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  const goOut = (e) =>{
    e.preventDefault()
    let data = {
      deviceId:`${userAgent[1]}`,
      userName: "jed@ifabula.com", 
      spajNumber:"9004311"
   }
    dispatch(logOut(data))
    cookie.remove('accessToken')
    cookie.remove('refreshToken')
    navigate(`/${data.spajNumber}`)
  }

  // useEffect(()=>{
  //   let detailData={
  //     deviceId:`${userAgent[1]}`,
  //     userName: "jed@ifabula.com", 
  //     spajNumber:"9004311"
  //   }
  //   dispatch(getDetail(detailData))
  //   let xxx = cookie.get('accessToken')
  // },[])

  const navigatePage = () => {
    navigate('/ilustrasi');
  }


  return (
    <>
      <div>
            
        <div className="g-0 welcome-container">
          <div className={`position-relative ${styles.bgContainer}`}>
                    <div className={styles.cardContainer}>
                        <div>Bapak xxxx No SPAJ xxxx</div>
                        <div>Pengajuan Asuransi Jiwa Sedang Dalam Proses perubahan data, mohon menghubungi agen anda untuk update data terkini </div>
                    </div>
                   
                   
          </div>
        </div>
        
    </div>
    </>
    // <div>
    //   <h1>Selamat Datang! {SPAJDetail.dataSpaj?.fullName} SPAJ {SPAJDetail.dataSpaj?.spajNumber}</h1>
    //   <button onClick={(e)=>goOut(e)}>logOut</button>
    // </div>
  )
}
